'use client';

import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { X } from 'lucide-react';
import {
  SortOption,
  type FilterOption,
  getSortLabel,
  type Gender,
} from '@/types/tournament.model';
import { getGenderLabel } from '@/utils/gender-utils';

interface ActiveFiltersProps {
  searchQuery: string;
  setSearchQuery: (query: string) => void;
  genderFilter: FilterOption;
  setGenderFilter: (filter: FilterOption) => void;
  sortBy: SortOption;
  setSortBy: (sort: SortOption) => void;
  resetFilters: () => void;
}

export function ActiveFilters({
  searchQuery,
  setSearchQuery,
  genderFilter,
  setGenderFilter,
  sortBy,
  setSortBy,
  resetFilters,
}: ActiveFiltersProps) {
  // Only show if there are active filters
  if (
    !(searchQuery || genderFilter !== 'all' || sortBy !== SortOption.TEAM_ASC)
  ) {
    return null;
  }

  return (
    <div className="mb-4 flex flex-wrap items-center gap-2">
      <span className="text-sm text-gray-500">Filtros activos:</span>

      {searchQuery && (
        <Badge
          variant="outline"
          className="flex items-center gap-1 border-green-200 bg-green-50 text-green-800"
        >
          Búsqueda: {searchQuery}
          <Button
            variant="ghost"
            size="icon"
            className="ml-1 h-4 w-4 p-0"
            onClick={() => setSearchQuery('')}
          >
            <X className="h-3 w-3" />
          </Button>
        </Badge>
      )}

      {genderFilter !== 'all' && (
        <Badge
          variant="outline"
          className="flex items-center gap-1 border-green-200 bg-green-50 text-green-800"
        >
          Género: {getGenderLabel(genderFilter as Gender)}
          <Button
            variant="ghost"
            size="icon"
            className="ml-1 h-4 w-4 p-0"
            onClick={() => setGenderFilter('all')}
          >
            <X className="h-3 w-3" />
          </Button>
        </Badge>
      )}

      {sortBy !== SortOption.TEAM_ASC && (
        <Badge
          variant="outline"
          className="flex items-center gap-1 border-green-200 bg-green-50 text-green-800"
        >
          Orden: {getSortLabel(sortBy)}
          <Button
            variant="ghost"
            size="icon"
            className="ml-1 h-4 w-4 p-0"
            onClick={() => setSortBy(SortOption.TEAM_ASC)}
          >
            <X className="h-3 w-3" />
          </Button>
        </Badge>
      )}

      <Button
        variant="ghost"
        size="sm"
        className="ml-auto text-xs"
        onClick={resetFilters}
      >
        Limpiar filtros
      </Button>
    </div>
  );
}
